const loadGoogleMaps = (apiKey, version, language) => {
    try {
        if (typeof window === 'undefined' || typeof document === 'undefined') {
            return;
        }

        if (typeof window.google === 'object' && typeof window.google.maps === 'object') {
            if (typeof window.google.maps.places === 'object') {
                return;
            }

            throw new Error('Google is already loaded, but does not contain the places API.');
        }

        if (!window.vgaMapState.initMap) {
            const googleMapScript = document.createElement('SCRIPT');

            const options = {};
            if (typeof apiKey === 'string') {
                options.key = apiKey;
            } else if (typeof apiKey === 'object') {
                Object.keys(apiKey).forEach(key => {
                    options[key] = apiKey[key];
                });
            } else {
                throw new Error('apiKey should either be a string or an object');
            }

            options.libraries = 'places';
            options.callback = 'initVGAMaps';

            const parameters = Object.keys(options)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(options[key])}`)
                .join('&');

            let url = `https://maps.googleapis.com/maps/api/js?${parameters}`;

            if (version) {
                url = `${url}&v=${version}`;
            }

            if (language) {
                url = `${url}&language=${language}`;
            }

            googleMapScript.setAttribute('src', url);
            googleMapScript.setAttribute('async', '');
            googleMapScript.setAttribute('defer', '');
            document.body.appendChild(googleMapScript);
        } else {
            throw new Error('Vuetify google autocomplete loaded multiple times.');
        }
    } catch (exception) {
        throw new Error('Vuetify google autocomplete load error: ', exception);
    }
};

export default loadGoogleMaps;
